import { useState, useEffect } from "react";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";
import { Message } from "../../components/Message";
import { Checkbox } from "../../components/Checkbox";
import { If } from "../../components/control-statements/If";
import styles from "../../../styles/integrations.module.scss";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";

function RequestPermissionStep({
  loading,
  account,
  onConfirm,
  error,
  readOnly,
}) {
  const [apiToken, setApiToken] = useState(null);
  const [storeId, setStoreId] = useState(null);
  const [showTrackingUrl, setShowTrackingUrl] = useState(null);
  const [cancelationControl, setCancelationControl] = useState(null);
  const [allowPreview, setAllowPreview] = useState(null);

  const environmentConfigurations = EnvironmentStorage.getConfigurations();

  useEffect(() => {
    if (account?.apiToken) {
      setApiToken(account.apiToken);
    if (showTrackingUrl === null)
      setShowTrackingUrl(account?.showTrackingUrl || false);
    }

    if (account?.cancelationControl) {
      setCancelationControl(account?.cancelationControl) 
    }

    if (account?.allowPreview) {
      setAllowPreview(account?.allowPreview) 
    }

    if (account?.storeId) {
      setStoreId(account?.storeId);
    }
  }, []);

  const handleShowTrackingUrl = async () => {
    setShowTrackingUrl(!showTrackingUrl);
  };

  const handleCancelationControl = async () => {
    setCancelationControl(!cancelationControl);
  };

  const handleAllowPreview = async () => {
    setAllowPreview(!allowPreview);
  };

  return (
    <>
      {readOnly !== true && (
        <div className={styles.header}>
          <div className={styles.about}>
            <p className={styles.title}>Permissão de acesso</p>
            <p className={styles.description}>
              Para que essa integração funcione, é necessário dar permissão de
              acesso ao Olga Food na sua conta da Mottu.
            </p>
            <p className={styles.description}>
              Informe o token de acesso à conta da Mottu: <strong className={styles.highlight}>x-api-token</strong>
              , fornecido pelo suporte da Mottu durante a ativação da integração.
            </p>
            <p className={styles.description}>
              Informe o <strong className={styles.highlight}>ID</strong> do lojista/responsável, obtido no painel da Mottu.
            </p>
          </div>
        </div>
      )}
      <Input
        design="two"
        name="apiToken"
        floatLabel="Token de acesso à API"
        className="mt-30"
        value={apiToken}
        onChange={(e) => setApiToken(e.target.value)}
        disabled={readOnly || loading}
      />

      <If cond={environmentConfigurations.type === "UNIT"}>
        <Input
          design="two"
          name="storeId"
          floatLabel="ID da loja na Mottu"
          className="mt-20"
          value={storeId}
          onChange={(e) => setStoreId(e.target.value)}
          disabled={readOnly || loading}
        />
      </If>

      {error && (
        <div className="mt-20">
          <Message text={error} />
        </div>
      )}

      <Checkbox
        name="showTrackingUrl"
        design="two"
        className="mt-20"
        checked={showTrackingUrl}
        onChange={
          readOnly !== true ? (e) => handleShowTrackingUrl(e) : null
        }
      >
        Exibir URL para acompanhamento
      </Checkbox>

      <Checkbox
        name="cancelationControl"
        design="two"
        className="mt-10"
        checked={cancelationControl}
        onChange={
          readOnly !== true ? (e) => handleCancelationControl(e) : null
        }
      >
        Cancelar pedido quando o operador logístico cancelar ou não conseguir efetuar a entrega?{" "}
      </Checkbox>

      <Checkbox
        name="allowPreview"
        design="two"
        className="mt-10"
        checked={allowPreview}
        onChange={
          readOnly !== true ? (e) => handleAllowPreview(e) : null
        }
      >
        Utilizar valor do frete da Mottu?{" "}
      </Checkbox>
      

      {readOnly !== true && (
        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            onClick={async () => await onConfirm(apiToken, storeId, showTrackingUrl, cancelationControl, allowPreview)}
            loading={loading}
            disabled={loading || !apiToken || (!storeId && environmentConfigurations.type === "UNIT")}
          >
            Dar permissão
          </Button>
        </div>
      )}
    </>
  );
}

export { RequestPermissionStep };
